import React from 'react'

export default function Blogpost() {
  return (
    <div>Blogpost</div>
  )
}
